import { uid } from '../../../../lib/uid';
import type { PressReleaseChannelRequest } from '../pressReleaseTypes';

const CHANNELS = [
  { name: 'Facebook', description: 'The organization’s Facebook page.' },
  { name: 'Website', description: 'The news section of the organization’s website.' },
  { name: 'Instagram', description: 'The organization’s Instagram account.' },
  { name: 'X', description: 'The organization’s X account.' },
  { name: 'YouTube', description: 'The organization’s YouTube channel.' },
];

/**
 * A synthetic channel, for filling the form in one click. The name is unique among live rows, so
 * it is SUFFIXED — the second click must not collide.
 */
export function sampleChannel(): PressReleaseChannelRequest {
  const picked = CHANNELS[Math.floor(Math.random() * CHANNELS.length)];

  return { name: `${picked.name} ${uid().slice(0, 6).toUpperCase()}`, description: picked.description };
}
